
import BookingsTable from "@/components/bookings/BookingsTable.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    BookingsTable,
  },
})
export default class BookingsView extends Vue {
  //
}
